import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface MarginProp {
	marginTop?: string;
}

export const Root = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',

	'& > div:first-of-type': {
		marginBottom: '24px',
	},
}));

export const Title = styled(Typography)(({ theme }) => ({
	...theme.typography.body1,

	'& > span:nth-of-type(2n)': {
		fontWeight: '600',
	},
}));

export const Description = styled(Typography)<MarginProp>(
	({ theme, marginTop }) => ({
		...theme.typography.body2,
		color: theme.palette.neutral[80],
		marginTop: marginTop || 0,
	})
);
